(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        this.handleIntersection = this.handleIntersection.bind(this);

        this.observer = new IntersectionObserver(
          this.handleIntersection,
          {
            rootMargin: '0px 0px 200px 0px'
          }
        );

        this.observer.observe(this);
      }

      handleIntersection(entries) {
        if (!entries[0].isIntersecting) {
          return;
        }

        this.observer.unobserve(this);

        const requestUrl = this.dataset.url;

        if (!requestUrl) {
          return;
        }

        fetch(requestUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                `Product recommendations request failed: ${response.status}`
              );
            }

            return response.text();
          })
          .then((responseText) => {
            const html = document.createElement('div');

            html.innerHTML = responseText;

            const recommendations = html.querySelector(
              'product-recommendations'
            );

            if (
              recommendations &&
              recommendations.innerHTML.trim().length
            ) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add(
                'product-recommendations--loaded'
              );
            }
          })
          .catch((error) => {
            console.error(
              'Product recommendations error:',
              error
            );
          });
      }
    }

    customElements.define(
      'product-recommendations',
      ProductRecommendations
    );
  }

  } catch(e) { console.error(e); }
})();
})();
